import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';
export const TRADE_APPLY_RECORD_TYPES = [
  'AllotTradeApplyRecord',
  'RedeemTradeApplyRecord',
]

const entityColumns = {
  id: {
    model_name: 'TradeApplyRecord',
    column_type: 'id',
  },
  created_at: {
    model_name: 'TradeApplyRecord',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'TradeApplyRecord',
    column_type: 'datetime',
  },
  type: {
    model_name: 'TradeApplyRecord',
    column_type: 'type',
    extra: {
      options: ['AllotTradeApplyRecord', 'RedeemTradeApplyRecord'],
    },
  },
  amount: {
    model_name: 'TradeApplyRecord',
    column_type: 'decimal',
  },
  share: {
    model_name: 'TradeApplyRecord',
    column_type: 'decimal',
  },
  value: {
    model_name: 'TradeApplyRecord',
    column_type: 'decimal',
  },
  account: {
    model_name: 'TradeApplyRecord',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'account',
      model_name: 'Account',
      foreign_key: 'account_id',
    },
  },
  account_id: {
    model_name: 'TradeApplyRecord',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'account',
      model_name: 'Account',
      foreign_key: 'account_id',
    },
  },
  applicant: {
    model_name: 'TradeApplyRecord',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'applicant',
      model_name: 'Account',
      foreign_key: 'applicant_id',
    },
  },
  applicant_id: {
    model_name: 'TradeApplyRecord',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'applicant',
      model_name: 'Account',
      foreign_key: 'applicant_id',
    },
  },
  fund: {
    model_name: 'TradeApplyRecord',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'fund',
      model_name: 'Fund',
      foreign_key: 'fund_id',
    },
  },
  fund_id: {
    model_name: 'TradeApplyRecord',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'fund',
      model_name: 'Fund',
      foreign_key: 'fund_id',
    },
  },
  state: {
    model_name: 'TradeApplyRecord',
    column_type: 'enum',
  },
  reject_reason: {
    model_name: 'TradeApplyRecord',
    column_type: 'string',
  },
  confirm_file: {
    model_name: 'TradeApplyRecord',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
}

export const columnsExtend = (columns, filterColumnsExtend) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns, filterColumnsExtend)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
